import { Component } from '@angular/core';
import { DialogBoxData, DialogBoxService, DialogBoxType } from 'dialog-box';
import { ModeVersion } from 'info';
import { ModalBoxService } from 'modal-box';
import { ElectronService } from 'ngx-electron';
import { IpcService } from 'src/app/services/ipc.service';
import { ReplayService } from 'src/app/services/replay.service';

@Component({
  selector: 'app-replay-analizer-export',
  templateUrl: './replay-analizer-export.component.html',
  styleUrl: './replay-analizer-export.component.scss'
})
export class ReplayAnalizerExportComponent
{
  waiting = true;
  processing = false;
  error = false;
  exported = false;

  constructor(private modalBoxService: ModalBoxService,
              private electronService:ElectronService,
              private ipcService:IpcService,
              private replayService:ReplayService,
              private dialogService:DialogBoxService)
  {}

  export()
  {
    if(this.electronService.isElectronApp)
    {
      if(this.ipcService.info.mode === ModeVersion.PRODUCTION && !this.ipcService.drive)
      {
        this.dialogService.show(new DialogBoxData({
          type: DialogBoxType.ALERT,
          message: 'inserte_usb'
        }));
      }
      else
      {
        this.waiting = false;
        this.processing = true;

        this.replayService.exportAnalysis(this.modalBoxService.data).then((response) =>
        {
          const path = response.message;

          if(path)
          {
            let res = '';

            this.ipcService.saveFile(path)
            .then((result) => res = result)
            .catch((err) => res = err)
            .finally(() =>
            {
              this.processing = false;
              this.exported = false;
              this.error = false;

              if(res == 'saved')
                this.exported = true;
              else if(res == 'error')
                this.error = true;
            });
          }
          else
          {
            this.processing = false;
            this.error = true;
          }
        },
        err =>
        {
          this.processing = false;
          this.error = true;

          if(typeof(err) === 'string')
          {
            this.dialogService.show(new DialogBoxData({
              type: DialogBoxType.ALERT,
              message: err
            }));
          }
        });
      }
    }
  }

  close()
  {
    this.modalBoxService.hide();
  }
}
